export const PHONE_MASK = "(99) 9999-9999";
export const NINTH_DIGIT_PHONE_MASK = "(99) 9999-99999";
export const CELL_PHONE_MASK = "(99) 99999-9999";

export const unformatPhone = (value) => {
  return value.replace(/[^\d]/g, "");
};

export const formatPhone = (value) => {
  const mask = value.length === 11 ? CELL_PHONE_MASK : PHONE_MASK;
  const shape = mask.split("");

  let valueIndex = 0;
  shape.forEach((shapeUnit, shapeUnitIndex) => {
    const currentNumber =
      typeof value[valueIndex] === "string" ? value[valueIndex] : " ";

    if (shapeUnit === "9") {
      shape[shapeUnitIndex] = currentNumber;
      valueIndex++;
    }
  });

  return shape.join("");
};

export const formatCNPJ = (value) => {
  const invertedForm = "00.000.000/0000-00".split("").reverse();
  const invertedData = value.split("").reverse();

  let dataIndex = 0;
  for (let formIndex = 0; formIndex < invertedForm.length; formIndex++) {
    if (invertedForm[formIndex] !== "0") {
      continue;
    }

    if (dataIndex >= invertedData.length) {
      break;
    }

    invertedForm[formIndex] = invertedData[dataIndex];
    dataIndex++;
  }

  return invertedForm.reverse();
};

export const unformatCNPJ = (value) => {
  return value.replace(/[^\d]/g, "");
};

const form = {
  PHONE_MASK,
  CELL_PHONE_MASK,
  formatPhone,
  unformatCNPJ,
  unformatPhone,
};

export default form;
